module.exports = __webpack_public_path__ + "img/greater_faerie_fire.73c16b0a.png";